import { EFinancingCompany } from '@if/core/types'

/** The same path in another company. */
export const replaceCompany = (pathname: string, company: EFinancingCompany): string =>
  pathname.replace(/^\/[^/]*/, `/${company}`)

// A route param named `id` or `…Id` (`:id`, `:loanId`, `:fileId`) names a record of the company being left. Any
// other param — a tab, a section — picks a view, which switching company keeps.
const isRecordParam = (name: string): boolean => name === 'id' || name.endsWith('Id')

/**
 * Where the selector lands in another company: the same screen, cut before the first record id, which does not
 * exist there. `/:company/loans/:id/:tab?` goes back to `/:company/loans`,
 * `/:company/accounting/acp-files/:fileId/detail` to `/:company/accounting/acp-files`.
 */
export const toCompanySwitchPath = (
  pathname: string,
  params: Record<string, string | undefined>,
  company: EFinancingCompany,
): string => {
  const recordIds = Object.entries(params)
    .filter(([name, value]) => isRecordParam(name) && value)
    .map(([, value]) => value)
  const segments = pathname.split('/')
  const firstRecordIndex = segments.findIndex(
    (segment, index) => index > 1 && recordIds.includes(decodeURIComponent(segment)),
  )
  const screenSegments = firstRecordIndex === -1 ? segments : segments.slice(0, firstRecordIndex)
  return replaceCompany(screenSegments.join('/'), company)
}
